import { I18n } from 'react-redux-i18n';

function BannerValidator({
  name, description,
}) {
  if (!name) return { message: I18n.t('nameImageRequire') };
  if (!description) return { message: I18n.t('descriptionImageRequire') };
  return { message: '', success: true };
}

function ManufacturerValidator({
  name, description,
}) {
  if (!name) return { message: I18n.t('nameImageRequire') };
  if (!description) return { message: I18n.t('descriptionImageRequire') };
  return { message: '', success: true };
}

function admMenuValidator({
  level, title, parent,
}) {
  if (!level) return { message: I18n.t('levelRequire') };
  if (level < 1 || level > 5) return { message: I18n.t('wrongLevel') };
  if (level > 1 && !parent) return { message: I18n.t('parentMenuRequire') };
  if (!title) return { message: I18n.t('titleRequire') };
  return { message: '', success: true };
}

function accessProfileValidator({
  profile, description,
}) {
  if (!profile) return { message: I18n.t('profileRequire') };
  if (!description) return { message: I18n.t('descriptionRequire') };
  return { message: '', success: true };
}

function isEmailValid(email) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

function adminUserFormValidator({
  email, name, password, passwordConfirm, isUpdating = false,
}) {
  if (!isEmailValid(email)) {
    return {
      message: I18n.t('invalidEmail'),
      isValid: false,
    };
  }

  if (!name) {
    return {
      message: I18n.t('insertFirstName'),
      isValid: false,
    };
  }
  if (!isUpdating) {
    if (!password || !passwordConfirm) {
      return {
        message: I18n.t('noPassword'),
        isValid: false,
      };
    }

    if (password !== passwordConfirm) {
      return {
        message: I18n.t('passwordDifferents'),
        isValid: false,
      };
    }

    if (password.length < 5 || password.length > 50) {
      return {
        message: I18n.t('passwordText'),
        isValid: false,
      };
    }
  }

  return {
    message: '',
    isValid: true,
  };
}

function placeValidator({
  codeBu, codePlace,
}) {
  if (!codeBu) return { message: I18n.t('buRequire') };
  if (!codePlace) return { message: I18n.t('placeRequire') };
  return { message: '', success: true };
}

function categoryFamilyValidator({
  codeFamily, categoryId,
}) {
  if (!codeFamily) return { message: 'Família é Obrigatório' };
  if (!categoryId) return { message: 'Categoria é Obrigatório' };
  return { message: '', success: true };
}

export default {
  accessProfileValidator,
  admMenuValidator,
  BannerValidator,
  ManufacturerValidator,
  isEmailValid,
  adminUserFormValidator,
  placeValidator,
  categoryFamilyValidator,
};
